import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GetTokenAndURLParams, GetTokenAndURLResponse } from '..';

@Injectable({
  providedIn: 'root',
})
export class ChartioService {
  private _url = environment.chartioUrl;

  constructor(private http: HttpClient) {}

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  getTokenAndURL(
    getTokenAndURLParams: GetTokenAndURLParams
  ): Observable<GetTokenAndURLResponse> {
    let params = new HttpParams();

    Object.keys(getTokenAndURLParams).forEach((param) => {
      params = params.append(param, getTokenAndURLParams[param]);
    });

    return this.http
      .get(this._url, { params })
      .pipe(catchError(this.formatErrors))
      .pipe(map((data: GetTokenAndURLResponse) => data));
  }
}
